import Node from './Node';
import CollectionNode from './CollectionNode';
import * as _ from 'lodash';
import TextType from './TextType';

export default class VectorNode extends CollectionNode {

	public normalized () {
		return new VectorNode(_.uniqBy(this.getNormalizedElements(), element => element.toText()));
	}

	public toText (textType = TextType.PLAIN) {
		return super.toText(textType);
	}

	protected create (value: Node[]) {
		return new VectorNode(value);
	}

	protected getTextPrefix (textType?: TextType) {
		return textType === TextType.LATEX ? '\\begin{bmatrix}' : '<';
	}

	protected getTextInfix (textType?: TextType) {
		return '\\\\';
	}

	protected getTextPostfix (textType?: TextType) {
		return textType === TextType.LATEX ? '\\end{bmatrix}' : '>';
	}
}


// WEBPACK FOOTER //
// ./code/project/modules/parsing/nodes/VectorNode.ts